import React, { useRef, useState } from 'react';

const SubmitBriefIframePage = () => {
  const iframeRef = useRef(null);
  const [iframeLoaded, setIframeLoaded] = useState(false);

  const iframeSrc =
    window.location.hostname === 'localhost'
      ? 'http://localhost:3000/client-briefs/add?embed=true&source=npc'
      : 'https://www.propsourcing.com.au/client-briefs/add?embed=true&source=npc';

  return (
    <div className="min-h-screen p-6">
      <h1 className="text-2xl font-bold text-center mb-4 text-[#003366]">Let the matching engine work for you !</h1>
      <iframe
        ref={iframeRef}
        src={iframeSrc}
        title="Submit Client Brief"
        width="100%"
        height="1000"
        className="border rounded shadow"
        onLoad={() => setIframeLoaded(true)}
      />
    </div>
  );
};

export default SubmitBriefIframePage;
